import type { ReactNode } from 'react'
import styles from './EmptyState.module.css'

export interface EmptyStateProps {
  readonly glyph?: string
  readonly title: string
  readonly body?: string
  readonly actions?: ReactNode
}

/**
 * The brief: "Handle the empty state properly. The MVP launches with no
 * historical data at all." This is the default view on day one, not an edge
 * case, so it is a first-class primitive rather than an `if (!rows.length)`
 * scattered through each screen.
 */
export function EmptyState({ glyph = '◍', title, body, actions }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <span className={styles.glyph} aria-hidden="true">
        {glyph}
      </span>
      <p className={styles.title}>{title}</p>
      {body && <p className={styles.body}>{body}</p>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}
